import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Configura tus credenciales de Firebase aquí
const firebaseConfig = {
  apiKey: "AIzaSyA92FBI56WDq5MANJYD2qpqoPnNmlBV6xw",
  authDomain: "finanzas-personales-99eb3.firebaseapp.com",
  projectId: "finanzas-personales-99eb3",
  storageBucket: "finanzas-personales-99eb3.firebasestorage.app",
  messagingSenderId: "937495752140",
  appId: "1:937495752140:web:bd498cadddebfd09cf8169"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
